import axios from "axios";
import { ISurvey } from "../classes/Survey";
import { SurveyConverterFactory } from "../classes/data-conversion/SurveyConverter";
import SurveyFaker from "../classes/SurveyFaker";
import { IQuestion } from "../classes/Question";
import { QuestionsConverter } from "../classes/data-conversion/QuestionsConverter";


export class SurveyService {
    private static allSurveysURL: string = "https://survey-app-backend.azurewebsites.net/api/native/surveys/allSurveys/"; //d09675f1-5567-4d98-9e73-44e1ecd3c3bb";
    private static singleSurveyFullURL: string = "https://survey-app-backend.azurewebsites.net/api/native/surveys/singleSurveyFull/";
    private static singleSurveyWithRURL: string = "https://survey-app-backend.azurewebsites.net/api/native/surveys/singleSurveyWithR/";

    /**
     * Optimized method to fetch all survey data in a single call
     * Makes only 2 backend requests (Full + WithR) instead of 6-7
     * Returns survey, questions, and title together
     */
    public static async getSurveyWithQuestions(id: string): Promise<{
        survey: ISurvey,
        questions: IQuestion[],
        title: string
    }> {
        // Make both API calls in parallel
        const [singleSurveyFull, singleSurveyWithR] = await Promise.all([
            axios.get(this.singleSurveyFullURL + id),
            axios.get(this.singleSurveyWithRURL + id)
        ]);

        const rawDataFull = singleSurveyFull.data;
        const rawDataWithR = singleSurveyWithR.data;

        // Convert survey
        const surveyConverterFactory = new SurveyConverterFactory();
        const surveyConverter = surveyConverterFactory.createConverter("enps", rawDataFull, rawDataWithR);
        const survey = surveyConverter.createSurvey();

        // Attach raw responses to survey for time-based calculations
        (survey as any).native_responses = rawDataWithR.native_responses || [];
        (survey as any).createdAt = rawDataWithR.createdAt;
        (survey as any).updatedAt = rawDataWithR.updatedAt;

        // Convert questions
        const dataConverter = new QuestionsConverter(rawDataFull, rawDataWithR);
        const questions = dataConverter.createQuestions();

        return {
            survey,
            questions,
            title: survey.title
        };
    }

    public static async getAllSurveys(id="d09675f1-5567-4d98-9e73-44e1ecd3c3bb"): Promise<ISurvey[]> {
        let allSurveys = [] as ISurvey[];
        allSurveys = (await axios.get(this.allSurveysURL+id)).data;
        console.log("all Surverys: SurveyService.ts: allSurveys: ",allSurveys);
        //allSurveys = SurveyFaker.generateSurveys(10);
        return allSurveys;
    }

    public static async getSurvey(id: string): Promise<ISurvey> {
        console.log("gg game");
        let singleSurvey = {} as ISurvey;

        let singleSurveyFull: any = (await axios.get(this.singleSurveyFullURL + id));
        let singleSurveyWithR: any = (await axios.get(this.singleSurveyWithRURL + id));

        const surveyConverterFactory = new SurveyConverterFactory();
        const surveyConverter = surveyConverterFactory.createConverter("enps", singleSurveyFull.data, singleSurveyWithR.data);
        singleSurvey = surveyConverter.createSurvey();
        console.log("Single survey:");
        console.log(singleSurvey);
        console.log(singleSurvey.title);
        const singleSuveyTitle = singleSurvey.title;
        /*
        let singleSurveyFake = SurveyFaker.generateSurvey("generic");
        let i=0;
        singleSurvey.dimensions.map(dimension => {
            return dimension.score = singleSurveyFake.dimensions[i++].score;
        })
        */

        //singleSurvey = SurveyFaker.generateSurvey("generic");
        return singleSurvey;
    }
    
    public static async getSurveyRaw(id: string): Promise<any> {
        // Get survey with all responses without processing
        let singleSurveyWithR: any = (await axios.get(this.singleSurveyWithRURL + id));
        return singleSurveyWithR.data;
    }
    
    public static async getSurveyTitle(id: string): Promise<string> {
        console.log("gg game 2");
        let singleSurvey = {} as ISurvey;

        let singleSurveyFull: any = (await axios.get(this.singleSurveyFullURL + id));
        let singleSurveyWithR: any = (await axios.get(this.singleSurveyWithRURL + id));

        const surveyConverterFactory = new SurveyConverterFactory();
        const surveyConverter = surveyConverterFactory.createConverter("enps", singleSurveyFull.data, singleSurveyWithR.data);
        singleSurvey = surveyConverter.createSurvey();
        const singleSurveyTitle = singleSurvey.title;
        /*
        let singleSurveyFake = SurveyFaker.generateSurvey("generic");
        let i=0;
        singleSurvey.dimensions.map(dimension => {
            return dimension.score = singleSurveyFake.dimensions[i++].score;
        })
        */

        //singleSurvey = SurveyFaker.generateSurvey("generic");
        return singleSurveyTitle;
    }
    public static async getAllSurveysWithResponse(id="d09675f1-5567-4d98-9e73-44e1ecd3c3bb"): Promise<any[]> {
        console.log("llamada con id: get al surveys: ",id);
        let allSurveys = [] as ISurvey[];
        allSurveys = (await axios.get(this.allSurveysURL+id)).data;
        const ans = [];
        for(const current of allSurveys) {
            ans.push(await axios.get(this.singleSurveyWithRURL + current.id));
        }
        return ans;
    }

    public static async getSingleSurveyWithResponse(id="6b9403b7-8fcb-4828-bba8-8f600d447cf1"): Promise<any> {
        const ansSurvey = (await axios.get(this.singleSurveyWithRURL+id)).data;
        return ansSurvey;
    }
    public static async getSingleSurveyFull(id="6b9403b7-8fcb-4828-bba8-8f600d447cf1"): Promise<any> {
        const ansSurvey = (await axios.get(this.singleSurveyFullURL+id)).data;
        return ansSurvey;
    }
    

    public static async getAlSurveys() {
    }
}